


































































































































import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import url from 'url';
import { ISetting } from '../services/models/Setting';

interface ValidationInput {
    dirty: boolean;
    validated: boolean;
    valid: boolean;
}

@Component
export default class RIST extends Vue {
    private lurls: any[] = [];
    private parameters: { [key: string]: string } = {};
    private parametersIndex: { [key: number]: { [key: string]: string } } = {};
    private showNetworkBindings: boolean = false;

    @Prop({ default: [] }) private urls!: string[];
    @Prop({ default: '' }) private mode!: string;
    @Prop({ default: '' }) private id!: string;
    @Prop({ default: '' }) private name!: string;
    @Prop({ default: [] }) private settings!: ISetting[];
    @Prop({ default: {} }) private networkDevices!: { [key: string]: string };
    @Prop({ default: '' }) private AdvancedLockText!: string;
    @Prop({ default: true }) private advancedLock!: boolean;

    @Emit()
    private configurationChanged(newValue: string[]) {
        // dummy
    }

    @Emit()
    private typeChange(newUrl: string) {
        // dummy
    }

    @Watch('settings', { immediate: true})
    private onSettingsCahnge(newValue: ISetting[], oldValue: ISetting[]) {
        if (newValue && Array.isArray(newValue)) {
            for (const s of newValue) {
                if (s.key === 'server.nic_bindings_show' && s.value.toLowerCase() === 'true') {
                    this.showNetworkBindings = true;
                }
            }
        }
    }

    @Watch('urls', { immediate: true })
    private onURLSChange(newValue: string[], oldValue: string[]) {
        if (newValue) {
            this.lurls = [];
            this.parameters = {};
            let i: number = 0;

            newValue.forEach((u) => {
                const lurl: any = url.parse(u, false, false);
                this.lurls.push(lurl);
                this.parametersIndex[i] = {};

                // if (0 === i) {
                let params: string[] = [];
                if (lurl && lurl.query && lurl.query.indexOf('&') !== -1) {
                    params = lurl.query.split('&');
                } else if (lurl && lurl.query && lurl.query.indexOf('=') !== -1) {
                    params.push(lurl.query);
                }
                params.forEach((param) => {
                    if (param.indexOf('=') !== -1) {
                        const values = param.split('=');
                        if (values.length > 1) {
                            if (0 === i) {
                                this.parameters[values[0].toLowerCase()] = values[1];
                            }
                            this.parametersIndex[i][values[0].toLowerCase()] = values[1];
                        } else {
                            if (0 === i) {
                                this.parameters[values[0].toLowerCase()] = 'true';
                            }
                            this.parametersIndex[i][values[0].toLowerCase()] = 'true';
                        }
                    } else {
                        if (0 === i) {
                            this.parameters[param.toLowerCase()] = 'true';
                        }
                        this.parametersIndex[i][param.toLowerCase()] = 'true';
                    }
                });
                // }
                i++;
            });
        }
    }
    private remove() {
        this.configurationChanged([]);
    }

    private getValidationState(/*{ dirty, validated, valid = null }*/input: ValidationInput): any {
      return input.dirty || input.validated ? input.valid : null;
    }

    /*private parameterChanged(newValue: string, parameter: string, index: number = 0) {
        // Vue.set(this.parameters, parameter, newValue);
        if (index === 0) {
            Vue.set(this.parameters, parameter, newValue);
        }
        Vue.set(this.parametersIndex[index], parameter, newValue);
        // @ts-ignore
        Vue.set(
            this.lurls,
            0,
            url.parse(`rist://${this.Address(index)}:${this.Port(index)}?${this.buildParameters(index)}`, false, false),
        );

        const conf: string[] = [];
        this.lurls.forEach((u) => conf.push(u.href));

        this.configurationChanged(conf);
    }*/


    private parameterChanged(newValue: string, parameter: string, index: number = 0) {
        if (index === 0) {
            Vue.set(this.parameters, parameter, newValue);
        }
        Vue.set(this.parametersIndex[index], parameter, newValue);
        // @ts-ignore
        Vue.set(
            this.lurls,
            index,
            url.parse(`rist://${this.Address(index)}:${this.Port(index)}?${this.buildParameters(index)}`, false, false),
        );

        const conf: string[] = [];
        this.lurls.forEach((u) => conf.push(u.href));

        this.configurationChanged(conf);
    }

    private removeAddress(index: number) {
        Vue.delete(this.lurls, index);
    }

    private addAddress() {
        Vue.set(this.lurls, this.lurls.length, '');
    }

    private Address(index: number): string {
        if (this.lurls && this.lurls.length > 0) {
            return this.lurls[index].hostname;
        }

        return '';
    }

    private Port(index: number): number {
        if (this.lurls && this.lurls.length > 0) {
            return this.lurls[index].port;
        }

        return 0;
    }
    private get Buffer(): number {
        const param = 'buffer';
        if (this.parameters[param]) {
            return parseInt(this.parameters[param], 10);
        }

        return 120;
    }

    private get Secret(): string {
        const param = 'secret';
        if (this.parameters[param]) {
            return this.parameters[param];
        }

        return '';
    }

    private get Loglevel(): string {
        const param = 'bt-loglevel';
        if (this.parameters[param]) {
            return this.parameters[param];
        }

        return '3';
    }

    private get Profile(): number {
        const param = 'profile';
        if (this.parameters[param]) {
            return parseInt(this.parameters[param], 10);
        }

        return 0;
    }

    private get EncryptionType(): number {
        const param = 'encryption-type';
        if (this.parameters[param]) {
            return parseInt(this.parameters[param], 10);
        }

        return 0;
    }

    private get Tlpktdrop(): boolean {
        const param = 'tlpktdrop';
        if (this.parameters[param]) {
            return this.parameters[param] === 'true';
        }

        return true;
    }

    private get StreamId(): string {
        const param = 'streamid';
        if (this.parameters[param]) {
            return this.parameters[param];
        }

        return '';
    }

    private get Conntimeo(): number {
        const param = 'conntimeo';
        if (this.parameters[param]) {
            return parseInt(this.parameters[param], 10);
        }

        return 3000;
    }

    private get Groupconnect(): boolean {
        const param = 'groupconnect';
        if (this.parameters[param]) {
            return this.parameters[param] === 'true' || this.parameters[param] === '1';
        }

        return false;
    }

     private get UDP(): boolean {
        const param = 'udp';
        if (this.parameters[param]) {
            return this.parameters[param] === 'true' || this.parameters[param] === '1';
        }

        return false;
    }

    private get RTP(): boolean {
        const param = 'rtp';
        if (this.parameters[param]) {
            return this.parameters[param] === 'true' || this.parameters[param] === '1';
        }

        return false;
    }

    /*private buildParameters(index: number = 0) {
        if (index > 0) {
            return '';
        }

        let ret: string = '';
        Object.keys(this.parameters).forEach(
            (key) => {
                if (key === 'groupconnect') {
                    if (this.parameters[key]) {
                        ret += `${key}=1&`;
                    }
                } else {
                    ret += `${key}=${this.parameters[key]}&`;
                }
            },
        );

        return ret.substring(0, ret.length - 1);
    }*/

    private buildParameters(index: number = 0) {
        if (index > 0) {
         /*   if (this.parameterBTName[index] && this.parameterBTName[index] !== '') {
                return 'bt_name=' + this.parameterBTName[index];
            }*/
            // return '';
            if (this.parametersIndex[index]) {
                let r: string = '';
                Object.keys(this.parametersIndex[index]).forEach(
                    (key) => {
                        if (key === 'groupconnect') {
                            if (this.parametersIndex[index][key]) {
                                r += `${key}=1&`;
                            }
                        } else {
                            r += `${key}=${this.parametersIndex[index][key]}&`;
                        }
                    },
                );
                return r.substring(0, r.length - 1);
            }
            return '';
        }

        let ret: string = '';
        Object.keys(this.parameters).forEach(
            (key) => {
                if (key === 'groupconnect') {
                    if (this.parameters[key]) {
                        ret += `${key}=1&`;
                    }
                } else {
                    ret += `${key}=${this.parameters[key]}&`;
                }
            },
        );

        return ret.substring(0, ret.length - 1);
    }


    private addressChanged(newValue: string, index: number = 0): void {
        if (newValue.indexOf(':') !== -1 && newValue.indexOf('://') === -1) {
            if (newValue.indexOf('?') !== -1) { // also apply settings, will overwrite current settings
                this.typeChange(newValue);
                return;
            } else { // just change address and port, rest of settings are retained
                const addressAndPort = newValue.split(':');
                this.portChanged(addressAndPort[1], index);
                newValue = addressAndPort[0];
            }
        } else if (newValue.indexOf('://') !== -1 && index === 0) {
            this.typeChange(newValue);
            return;
        }
        // @ts-ignore
        Vue.set(
            this.lurls,
            index,
            url.parse(
                // @ts-ignore
                `rist://${newValue}:${this.Port(index)}?${this.buildParameters(index)}`,
                false,
                false,
            ),
        );
        const conf: string[] = [];
        this.lurls.forEach((u) => conf.push(u.href));

        this.configurationChanged(conf);
    }

    private portChanged(newValue: string, index: number = 0): void {
        // @ts-ignore
        Vue.set(
            this.lurls,
            index,
            url.parse(
                `rist://${this.Address(index)}:${
                    // @ts-ignore
                    newValue
                }?${this.buildParameters(index)}`,
                false,
                false,
            ),
        );

        const conf: string[] = [];
        this.lurls.forEach((u) => conf.push(u.href));

        this.configurationChanged(conf);
    }

    private get NetworkDevices(): any[] {
        const ret: any[] = [];

        ret.push({
            text: 'auto',
            value: '',
        });

        Object.keys(this.networkDevices).forEach((n) => {
            ret.push({
                text: `${n} (${this.networkDevices[n]})`,
                value: n,
            });
        });

        return ret;
    }

    private Bindtodevice(index: number): string {
        const param = 'miface';
        if (this.parametersIndex[index] && this.parametersIndex[index][param]) {
            return this.parametersIndex[index][param];
        }

        return '';
    }

    private get ShowBindtodevice(): boolean {
        const param = 'miface';
        if (this.showNetworkBindings) {
            return true;
        }

        for (let i: number = 0; i < this.lurls.length; i++) {
            if (this.parametersIndex[i] && this.parametersIndex[i][param]) {
                return true;
            }
        }
        return false;
    }
}
